module.exports = __webpack_public_path__ + "static/media/bg.7071c11b.png";